import React, { useState } from 'react';
import { Box, BoxProps } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { isOdd } from 'shared/lib/utils/utils';
import { sxMixins } from 'shared/lib/utils/uiConstants';
import map from 'lodash-es/map';
import ErrorNotification from 'shared/lib/components/lilUi/errorNotification';

const itemHeight = 50;
const minTreeHeight = 10 * itemHeight;

export default observer(function TreeContainer(
  props: BoxProps & { error?: string | null }
) {
  const [treeHeight, setTreeHeight] = useState(minTreeHeight);

  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        borderRadius: '12px',
        flexGrow: 1,
        ...(props.error
          ? {
              border: 1,
              borderColor: 'error.main',
            }
          : {}),
      }}
    >
      <Box
        sx={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0 }}
        ref={(el: null | HTMLDivElement) => {
          if (el) {
            setTreeHeight(el.offsetHeight);
          }
        }}
      >
        {map(new Array(Math.ceil(treeHeight / itemHeight)), (val, i) => {
          return (
            <Box
              key={i}
              sx={{
                bgcolor: isOdd(i + 1) ? '#F5F5F7' : '#FAFAFB',
                width: 1,
                height: itemHeight,
              }}
            ></Box>
          );
        })}
      </Box>
      <Box
        sx={{
          'display': 'flex',
          'position': 'relative',
          'minHeight': minTreeHeight,
          ...sxMixins.getScrollbarStyle({}),

          'overflow': 'auto',
          'pr': 4,
          '& .MuiAccordionSummary-content, & .MuiAccordionSummary-root, & .MuiPaper-root, & .MuiAccordionDetails-root':
            {
              bgcolor: 'transparent',
              py: '0px !important',
              my: '0px !important',
              width: 'max-content',
              flexGrow: 1,
            },
          '& .MuiAccordionDetails-root': {
            width: '100% !important',
          },
          '.MuiAccordionSummary-root': {
            minHeight: 'auto !important',
            height: itemHeight,
            maxHeight: itemHeight,
            width: 1,
          },
        }}
      >
        {props.error ? (
          <ErrorNotification
            sx={{ alignSelf: 'start', height: itemHeight, ml: 4 }}
            error={props.error}
          ></ErrorNotification>
        ) : (
          props.children
        )}
      </Box>
    </Box>
  );
});
